<template lang="html">
  <div class="group-select">
    <ul class="list-group d-block d-sm-flex">
      <template v-for="(item, index) in items">
        <li
          :class="['pl-3', 'py-3', 'py-sm-1', `${index === (items.length - 1) ? 'last' : ''}`]"
          :selected="selectedId === item.id"
          :key="'gsd-' + index"
          @click="handleClick(item.id)">
          {{ item.name }}
        </li>
      </template>
    </ul>
<!--    <div class="form-group d-block d-sm-none">-->
<!--      <select-->
<!--        :size="Math.min(items.length, 12)"-->
<!--        class="form-control"-->
<!--        @change="e => { selectedId = e.target.value }"-->
<!--        >-->
<!--        <template v-for="(item, index) in items">-->
<!--          <option-->
<!--            :key="'gsm-' + index"-->
<!--            :value="item.id" >-->
<!--            {{ item.name }}-->
<!--          </option>-->
<!--        </template>-->
<!--      </select>-->
<!--    </div>-->
  </div>
</template>

<script>
export default {
  props: {
    items: Array
  },

  data: () => ({
    selectedId: null
  }),

  methods: {
    handleClick (id) {
      this.selectedId = id
      this.$emit('selected', id)
    }
  },

  watch: {
    items () {
      this.selectedId = null
    }
  }
}
</script>

<style lang="scss">
  @import '../../../scss/colors';

  .group-select {
    & ul {
      border: solid 1px $gray-200;
      max-height: 50vh;
      overflow-y: auto;
      list-style: none;

      & li {
        border-bottom: 1px solid #eee;
        &.last {
          border-bottom: none;
        }
      }

      & li:hover {
        background-color: $primary;
        cursor: pointer;
        color: $white;
      }

      & li[selected] {
        background-color: $secondary;
        color: $white;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/forms/GroupSelect.vue